import * as React from "react";
import FieldWrapper, {GenericCheckbox, GenericDropdown,} from "../FieldWrapper";
import {SettingEnum, SettingPrefixEnum} from "../settingEnum";
import {
  bypassTimer,
  guardTime,
  sensorSupervisionCheckTimer,
  sensorSupervisionCheckTimerPendant,
  alarmSmsReceipt,
  sensorSensitivity,
  alarmButtonSensitivity,
  sensorSupervisionCheckTimerSTCB, sensorSupervisionCheckTimerPendantSTCB, guardTimeSTCB
} from "./options";
import {LabelEnum} from "../../LabelEnum";
import withFormWrapper from "@Elements/Form/formWrapper";
import InformationIcon from "../../../../Elements/Icon/Icons/InformationIcon";
import { TIME_OFFSET, status } from "@Elements/Form/utils";
import { DeviceSettings } from "../types";
import { DeviceHardwareEnum } from "@Safemate/DeviceHardwareEnum";

// Dropdowns
export const SensorSupervisionCheckTimer = FieldWrapper({
  componentOptions: {
    Component: GenericDropdown,
    props: {}
  },
  prefix: SettingPrefixEnum.DEVICE_SETTING,
  policyPrefix: SettingPrefixEnum.GENERAL,
  field: SettingEnum.SENSOR_SUPERVISION_CHECK_TIMER,
  title: LabelEnum.SENSOR_SUPERVISION_CHECK_TIMER,
  dataOptions: {
    options: sensorSupervisionCheckTimer,
    nullValue: status.disable,
    offset: TIME_OFFSET.SECONDS_IN_SECOND
  }
});

export const SensorSupervisionCheckTimerSTCB = FieldWrapper({
  componentOptions: {
    Component: GenericDropdown,
    props: {}
  },
  prefix: SettingPrefixEnum.DEVICE_SETTING,
  policyPrefix: SettingPrefixEnum.GENERAL,
  field: SettingEnum.SENSOR_SUPERVISION_CHECK_TIMER,
  title: LabelEnum.SENSOR_SUPERVISION_CHECK_TIMER,
  dataOptions: {
    options: sensorSupervisionCheckTimerSTCB,
    nullValue: status.disable,
    offset: TIME_OFFSET.SECONDS_IN_MINUTE
  }
});

export const SensorSupervisionCheckTimerPendant = FieldWrapper({
  componentOptions: {
    Component: GenericDropdown,
    props: {}
  },
  prefix: SettingPrefixEnum.DEVICE_SETTING,
  policyPrefix: SettingPrefixEnum.GENERAL,
  field: SettingEnum.SENSOR_SUPERVISION_CHECK_TIMER_PENDANT,
  title: LabelEnum.SENSOR_SUPERVISION_CHECK_TIMER_PENDANT,
  dataOptions: {
    options: sensorSupervisionCheckTimerPendant,
    nullValue: status.disable,
    offset: TIME_OFFSET.SECONDS_IN_SECOND,
    mapRoundDown: true
  }
});

export const SensorSupervisionCheckTimerPendantSTCB = FieldWrapper({
  componentOptions: {
    Component: GenericDropdown,
    props: {}
  },
  prefix: SettingPrefixEnum.DEVICE_SETTING,
  policyPrefix: SettingPrefixEnum.GENERAL,
  field: SettingEnum.SENSOR_SUPERVISION_CHECK_TIMER_PENDANT,
  title: LabelEnum.SENSOR_SUPERVISION_CHECK_TIMER_PENDANT,
  dataOptions: {
    options: sensorSupervisionCheckTimerPendantSTCB,
    nullValue: status.disable,
    offset: TIME_OFFSET.SECONDS_IN_MINUTE,
    mapRoundDown: true
  }
});

export const GuardTime = FieldWrapper({
  componentOptions: {
    Component: GenericDropdown,
    props: {}
  },
  prefix: SettingPrefixEnum.DEVICE_SETTING,
  policyPrefix: SettingPrefixEnum.GENERAL,
  field: SettingEnum.GUARD_TIME,
  title: LabelEnum.GUARD_TIME,
  dataOptions: {
    options: guardTime,
    nullValue: status.disable,
    offset: TIME_OFFSET.SECONDS_IN_SECOND
  }
});

export const GuardTimeSTCB = FieldWrapper({
  componentOptions: {
    Component: GenericDropdown,
    props: {}
  },
  prefix: SettingPrefixEnum.DEVICE_SETTING,
  policyPrefix: SettingPrefixEnum.GENERAL,
  field: SettingEnum.GUARD_TIME,
  title: LabelEnum.GUARD_TIME,
  dataOptions: {
    options: guardTimeSTCB,
    nullValue: status.disable,
    offset: TIME_OFFSET.SECONDS_IN_SECOND
  }
});

export const AlarmSmsReceipt = FieldWrapper({
  componentOptions: {
    Component: GenericDropdown,
    props: {}
  },
  prefix: SettingPrefixEnum.DEVICE_SETTING,
  policyPrefix: SettingPrefixEnum.GENERAL,
  field: SettingEnum.ALARM_SMS_RECEIPT,
  title: LabelEnum.ALARM_SMS_RECEIPT,
  dataOptions: {
    options: alarmSmsReceipt,
    skipMap: true,
    translate: true
  }
});

export const BypassTimer = FieldWrapper({
  componentOptions: {
    Component: GenericDropdown,
    props: {}
  },
  prefix: SettingPrefixEnum.DEVICE_SETTING,
  policyPrefix: SettingPrefixEnum.GENERAL,
  field: SettingEnum.BYPASS_TIMER,
  title: LabelEnum.BYPASS_TIMER,
  dataOptions: {
    options: bypassTimer,
    nullValue: status.disable,
    offset: TIME_OFFSET.SECONDS_IN_SECOND
  }
})

export const SensorSensitivity = FieldWrapper({
  componentOptions: {
    Component: GenericDropdown,
    props: {}
  },
  prefix: SettingPrefixEnum.DEVICE_SETTING,
  policyPrefix: SettingPrefixEnum.GENERAL,
  field: SettingEnum.SENSOR_SENSITIVITY,
  title: LabelEnum.SENSOR_SENSITIVITY,
  dataOptions: {
    options: sensorSensitivity,
    skipMap: true
  }
})

export const AlarmButtonSensitivity = FieldWrapper({
  componentOptions: {
    Component: GenericDropdown,
    props: {}
  },
  prefix: SettingPrefixEnum.DEVICE_SETTING,
  policyPrefix: SettingPrefixEnum.GENERAL,
  field: SettingEnum.ALARM_BUTTON_SENSITIVITY,
  title: LabelEnum.ALARM_BUTTON_SENSITIVITY,
  dataOptions: {
    options: alarmButtonSensitivity,
    skipMap: true,
    translate: true
  }
})

// Checkboxes
export const SensorSupervisionCheckActive = FieldWrapper({
  componentOptions: {
    Component: GenericCheckbox,
    props: {
      checkboxString: false,
      label: {id: LabelEnum.SENSOR_SUPERVISION_CHECK_ACTIVE, defaultMessage: "Sensorovervåking"}
    }
  },
  prefix: SettingPrefixEnum.DEVICE_SETTING,
  policyPrefix: SettingPrefixEnum.GENERAL,
  field: SettingEnum.SENSOR_SUPERVISION_CHECK_ACTIVE
});

export const LocalLearning = FieldWrapper({
  componentOptions: {
    Component: GenericCheckbox,
    props: {
      checkboxString: false,
      label: {id: LabelEnum.LOCAL_LEARNING, defaultMessage: "Aktiver lokal innlæring"}
    }
  },
  prefix: SettingPrefixEnum.DEVICE_SETTING,
  policyPrefix: SettingPrefixEnum.GENERAL,
  field: SettingEnum.LOCAL_LEARNING
});

export const ACLCheck = FieldWrapper({
  componentOptions: {
    Component: GenericCheckbox,
    props: {
      checkboxString: false,
      label: {id: LabelEnum.ACL_CHECK_LABEL, defaultMessage: "Call filter"},
      modal: true,
      modalActive: false,
      modalHeader: {id: "callFilterDisableModalHeader", defaultMessage: "Confirm action"},
      modalText: {id: "callFilterDisableModalMessage", defaultMessage: "Switching off the call filter means that everyone who knows the phone number of the device may enter a two-way call with device. Are you sure you want to continue?"},
      modalOkText: {id: "callFilterDisableModalOk", defaultMessage: "I understand the risk, proceed"},
      modalCancelText: {id: "callFilterDisableModalCancel", defaultMessage: "Abort"},
    }
  },
  prefix: SettingPrefixEnum.OTHER_SETTING,
  policyPrefix: SettingPrefixEnum.GENERAL,
  field: SettingEnum.ACL_CHECK
});


export const TeamAlertLearn = withFormWrapper<DeviceSettings, {}>(({ formik: { values: { teamAlertLearnUrl, teamAlertLearnUrlWatchFive, dehaId }}}) => {
 
  const url = dehaId === DeviceHardwareEnum.WATCH_FIVE ? teamAlertLearnUrlWatchFive : teamAlertLearnUrl
 
  if(!url) return null;
  return(
    <a target="_blank" href={url}><InformationIcon size="medium" /></a>
  )
})

export const TeamAlert = FieldWrapper({
  componentOptions: {
    Component: GenericCheckbox,
    props: {
      checkboxString: true,
      label: {id: LabelEnum.TEAM_ALERT, defaultMessage: "Kollegavarsling"},
      customTooltip: TeamAlertLearn
    }
  },
  prefix: SettingPrefixEnum.DEVICE_SETTING,
  policyPrefix: SettingPrefixEnum.GENERAL,
  field: SettingEnum.TEAM_ALERT
});

export const EnableOffButton = FieldWrapper({
  componentOptions: {
    Component: GenericCheckbox,
    props: {
      checkboxString: true,
      label: {id: "enableOffButton", defaultMessage: "Av-knapp aktivert"},
    }
  },
  prefix: SettingPrefixEnum.DEVICE_SETTING,
  policyPrefix: SettingPrefixEnum.GENERAL,
  field: SettingEnum.ENABLE_OFF_BUTTON
});


export const NotApplicable = FieldWrapper({
  componentOptions: {
    Component: GenericCheckbox,
    props: {
      checkboxString: false,
      label: {id: "notApplicable", defaultMessage: "Not applicable"},
    }
  },
  prefix: SettingPrefixEnum.DEVICE_SETTING,
  policyPrefix: SettingPrefixEnum.GENERAL,
  field: SettingEnum.NOT_APPLICABLE,
  disable: true,
});


export const WatchRemoved = FieldWrapper({
  componentOptions: {
    Component: GenericCheckbox,
    props: {
      checkboxString: false,
      label: {id: "watchRemoval", defaultMessage: "Watch removal alert"},
    }
  },
  prefix: SettingPrefixEnum.DEVICE_SETTING,
  policyPrefix: SettingPrefixEnum.GENERAL,
  field: SettingEnum.WATCH_REMOVED
});

export const AclCheck = FieldWrapper({
  componentOptions: {
    Component: GenericCheckbox,
    props: {
      checkboxString: false,
      label: {id: "aclCheckLabel", defaultMessage: "Call filter"},
    }
  },
  prefix: SettingPrefixEnum.DEVICE_SETTING,
  policyPrefix: SettingPrefixEnum.GENERAL,
  field: SettingEnum.ACL_CHECK
});
